import { HttpRequest } from '../../components/HttpRequest';
import secureLocalStorage from 'react-secure-storage';

export const featuredTeamsApi = {
  async getFeaturedTeams(searchValue = '') {
    try {
      const businessNumber = secureLocalStorage.getItem('businessId');
      const params = new URLSearchParams();
      if (businessNumber) {
        params.append('businessNumber', businessNumber);
      }
      if (searchValue) {
        params.append('searchValue', searchValue);
      }
      const queryString = params.toString();

      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/get_featured_teams${queryString ? `?${queryString}` : ''}`
      });

      if (response.status === 200 && response.response?.data) {
        // Transform the API response to match the component's expected format
        const teams = response.response.data.map((team) => ({
          id: team.teamId,
          name: team.name,
          code: team.code,
          gradient: team.gradient,
          textColor: team.textColor || '#ffffff',
          badge: team.badge,
          badgeColor: team.badgeColor,
        }));
        return teams;
      }
      return [];
    } catch (error) {
      console.error('Error fetching featured teams:', error);
      return [];
    }
  },
};
